<template>
    <div
        class="flex w-full flex-col py-2"
        :class="{
            'pl-2 text-base': indentationLevel === 0,
            'pl-[18px] text-sm': indentationLevel === 1,
        }"
    >
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ indentationLevel?: number }>(), {
    indentationLevel: 0,
});
</script>
